import React from 'react'

export const HeroInternas = ({title}) => {
    return (
        <div className="heroInternas">
            <img className="heroInternas--img" src='/images/background/banner-info-general.jpg' />
            <div className="heroInternas--div mb-base">
                <h1>{title}</h1>
            </div>
        </div>
    )
}
